var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pol\\xEDgono_15",
    "data-name": "Pol\\xEDgono 15",
    fill: "#e73758"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.69033718109131 16.75187492370605 L 9.293109893798828 13.5700101852417 L 9 13.35791015625 L 8.706890106201172 13.5700101852417 L 4.309658527374268 16.75187301635742 L 5.840610027313232 11.32979011535645 L 5.930369853973389 11.01185989379883 L 5.673140048980713 10.80459022521973 L 1.371860384941101 7.338691711425781 L 6.763440132141113 7.193749904632568 L 7.112639904022217 7.184360027313232 L 7.223939895629883 6.853229999542236 L 9 1.569308400154114 L 10.77606010437012 6.853219985961914 L 10.88735961914062 7.18435001373291 L 11.23655986785889 7.193739891052246 L 16.62814140319824 7.338689804077148 L 12.32686042785645 10.80459022521973 L 12.06962966918945 11.01185989379883 L 12.15939044952393 11.32977962493896 L 13.69033718109131 16.75187492370605 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.000000953674316 3.138656616210938 L 7.475290298461914 7.674790382385254 L 2.743732452392578 7.801992416381836 L 6.501330375671387 10.82979965209961 L 5.18161678314209 15.50373458862305 L 9 12.7407398223877 L 12.8183765411377 15.50373458862305 L 11.49867057800293 10.82979965209961 L 15.256272315979 7.80198860168457 L 10.52470970153809 7.674779891967773 L 9.000000953674316 3.138656616210938 M 9 0 L 11.25 6.693920135498047 L 18 6.87539005279541 L 12.64058017730713 11.19392013549805 L 14.56229972839355 18 L 9 13.9750804901123 L 3.437689781188965 18 L 5.359419822692871 11.19392013549805 L 0 6.87539005279541 L 6.75 6.693929672241211 L 9 0 Z",
    stroke: "none",
    fill: "#e73758"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled-star.6f234b4d410c3978a34cf1ed68f55740.svg";
export { ForwardRef as ReactComponent };